import moment from "moment";
import { calcolaPercentualeDiluizione } from "./diluizione_utils";

export default {
  props: {
    evento: Object,
  },
  data: () => ({
    dialog_elimina: false,
    loading_elimina: false,
    dialog_colture_trattate: false,
  }),
  computed: {
    data_evento() {
      return moment.unix(this.evento.ts).format("DD MMM YYYY");
    },
    fase_fenol() {
      switch (this.evento.fase_fenol) {
        case 0:
          return "Trapianto";
        case 1:
          return "Fase Vegetativa";
        case 2:
          return "Pre-Fioritura";
      }
      return "";
    },
    // Zona (legacy) e Serra (mappa) unite in un solo elenco per la colonna
    // "Zone Trattate": con eventi che coprono molte posizioni la lista di
    // chip diventerebbe altrimenti troppo lunga, quindi se ne mostrano solo
    // le prime 2 e le restanti finiscono in un chip "+N altre" con tooltip.
    zone_trattate_combinate() {
      let elenco = [];
      (this.evento.id_zone || []).forEach((id) => {
        elenco.push({ tipo: "zona", id, nome: this.nome_zona(id) });
      });
      (this.evento.id_serre || []).forEach((id) => {
        elenco.push({ tipo: "serra", id, nome: this.nome_serra(id) });
      });
      return elenco;
    },
    zone_trattate_visibili() {
      return this.zone_trattate_combinate.slice(0, 2);
    },
    zone_trattate_altre() {
      return this.zone_trattate_combinate.slice(2);
    },
    // Raggruppa le colture trattate per prodotto: lo stesso prodotto può
    // comparire più volte nell'evento con lotti diversi.
    gruppi_colture_trattate() {
      const map = {};
      const order = [];
      for (const item of this.evento.colture_trattate) {
        const id = item.id_coltura;
        if (!map[id]) {
          map[id] = { id_prodotto: id, items: [] };
          order.push(id);
        }
        map[id].items.push(item);
      }
      return order.map((id) => map[id]);
    },
  },
  methods: {
    fitofarmaco(id) {
      return this.$store.getters.get_fitofarmaco_by_id(id);
    },
    zona(id) {
      return this.$store.getters.get_zona_by_id(id);
    },
    nome_zona(id) {
      let zona = this.zona(id);
      return zona ? zona.nome : id;
    },
    nome_serra(id) {
      let serra = this.$store.getters.getSerraById(id);
      return serra ? serra.nome : id;
    },
    tipo_zona(tipo) {
      switch (tipo) {
        case 0:
          return "Serra con Bancali";
        case 1:
          return "Serra con Telo";
        case 2:
          return "Ombraio";
        case 3:
          return "Pieno Campo";
      }
    },
    avversita(id) {
      return this.$store.getters.get_avversita_by_id(id);
    },
    diluizione(qta) {
      return calcolaPercentualeDiluizione(qta, this.evento.volume_acqua);
    },
    elimina_evento() {
      this.loading_elimina = true;
      this.$store
        .dispatch("elimina_evento", { id_evento: this.evento.id })
        .then(() => {
          this.loading_elimina = false;
          this.dialog_elimina = false;
        });
    },
  },
};
